import React from 'react';
import { Styles } from './style';
import { Link } from 'react-router-dom';
import { ITipoImovel } from '@stores/Metadata/types';
import { useMetadataStore } from '@stores/Metadata/Metadata';

const TypeList = () => {
  const { tiposImovel } = useMetadataStore();

  // copies list from tiposImovel and when footer = true
  const List: ITipoImovel[] = Array.from(tiposImovel)
    .sort((a, b) => {
      if (a.ordem < b.ordem) return -1;
      if (a.ordem > b.ordem) return 1;
      return 0;
    })
    .filter((tipo) => tipo.footer === true);

  return (
    <Styles.ListContainer>
      <Styles.Title>Tipos de imóveis</Styles.Title>
      <Styles.FooterLinks>
        <Styles.UlOn>
          {List.map((imovel, index) => {
            const slug = imovel.titulo
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
              .replace(/ /g, '-');

            return (
              <Styles.LiOn key={index} style={{ listStyle: 'none' }}>
                <Link
                  to={`/pesquisar?tipoImovel=${encodeURIComponent(imovel.titulo)}`}
                  style={{
                    textDecoration: 'none',
                    color: 'inherit'
                  }}>
                  <Styles.ItemWithBorder>{imovel.titulo}</Styles.ItemWithBorder>
                </Link>
              </Styles.LiOn>
            );
          })}
        </Styles.UlOn>
      </Styles.FooterLinks>
    </Styles.ListContainer>
  );
};

export default TypeList;
